import React, { useState } from "react";
import { Avatar, styled, Tooltip } from "@mui/material";
import { getUserImageEndPoint, userUploadImage } from "../../../../api/user";
import ImageModal from "../../../helpers/ImageModal";
import useImageUpload from "../../../../hooks/useImageUpload";
import { getSession, setSession } from "../../../../bandung";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";

const StyledAvatar = styled(Avatar)`
  position: relative;
  background-color: #00000025;
  width: 128px;
  height: 128px;
  border: 2px ${props => props.theme.palette.text.disabled} solid;
  overflow: hidden;

  &:hover {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
`;

const UserImageDisplay = ({
  user,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const infoSnackbar = useInfoSnackbar();
  const imageUploadObj = useImageUpload();

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleImageSave = async () => {
    if (imageUploadObj.selectedImage !== null) {
      const response = await userUploadImage(
        imageUploadObj.selectedImage,
        user.userEntityId,
        imageUploadObj.handleUploadProgress,
      );
      if (response.code === "SUCCESS") {
        infoSnackbar.alertSuccess(response.message);
        if (getSession()?.userEntityId === user.userEntityId) {
          setSession({ ...getSession(), version: Date.now() });
        }
        window.location.reload();
      } else {
        infoSnackbar.alertError("Something went wrong...");
      }
    }
    imageUploadObj.reset();
  };

  return (
    <>
      <Tooltip title="View/Modify">
        <StyledAvatar
          alt={`${user.firstName} ${user.lastName}`}
          src={getUserImageEndPoint(user.userEntityId, user.version)}
          onClick={handleModalOpen}
        />
      </Tooltip>
      <ImageModal
        imageUrl={getUserImageEndPoint(user.userEntityId, user.version)}
        modalOpen={modalOpen}
        onModalClose={handleModalClose}
        onNewImageConfirmed={handleImageSave}
        imageUploadObj={imageUploadObj}
      />
    </>
  );
};

export default UserImageDisplay;
